import { Button, Tooltip } from '@mui/material';
import { FilterAlt as FilterAltIcon } from '@mui/icons-material';
import type { Command } from '../../menu/types';
import { normalizeCommandIcon } from '../utils/commandIconUtils';

type FilterPanelCommandButtonProps = {
  command: Command;
  visible: boolean;
  onToggle: () => void;
};

export const FilterPanelCommandButton = ({
  command,
  visible,
  onToggle,
}: FilterPanelCommandButtonProps) => {
  const customIcon = normalizeCommandIcon(command.icon);

  return (
    <Tooltip title={visible ? 'Hide filters' : 'Show filters'} arrow>
      <Button
        variant={visible ? 'contained' : 'outlined'}
        aria-pressed={visible}
        onClick={onToggle}
        size="medium"
        startIcon={customIcon ? <i className={customIcon} aria-hidden /> : <FilterAltIcon />}
      >
        {command.caption || 'Filters'}
      </Button>
    </Tooltip>
  );
};
